import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation, ResponsiveView, ShowConfirm, CustomBadges, CustomIcon, TableHeader, TableLoading,
} from "../../../../components";

import "./index.sass";
import ImageViewer from "../../../../components/ImageViewer";
import { useTranslation } from "react-i18next";
import PlateNumberr from "../../../../components/PlateNumberr";
import {useQuery} from "react-query";
import values from "../../../../values";
import api from "../../../../api";
import {DRIVER_HEADERS_COMPANY} from "../../../../values/tableHeaders";

const ApproveDocuments: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const {
    showModal,
    setShowModal,
    isLoading,
    selectedCompany,
    approveDocumentsFunction,
  } = React.useContext(Context.CompanyScreen);

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const resultDriver = useQuery(
    [`COMPANY_GET_OWN_DRIVER_${selectedCompany?._id}`],
    () =>
      api.post.common.findDriver({companyId: selectedCompany?._id}),
    {enabled: !!selectedCompany}
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================


  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id='show-company-driver-list-content'>
      <CustomModal
        onClose={() => setShowModal!('NONE')}
        open={showModal === 'SHOW_DRIVERS'}
        label="لیست داننگان"
        minWidth={'45rem'}
      >
        <ResponsiveView.Container>
          <ResponsiveView.Row>
            <UserInformation
              name        = { selectedCompany?.firstName   }
              avatar      = { selectedCompany?.avatar      }
              lastName    = { selectedCompany?.lastName    }
              phoneNumber = { selectedCompany?.phoneNumber }
            />
          </ResponsiveView.Row>
          <hr />
          <ResponsiveView.Row className='scroll-view'>
            <ResponsiveView.Column small={12}>
              <table className='table-driver'>
                <TableHeader headers={values.tableHeaders.DRIVER_HEADERS_COMPANY.map((item) => t(item))}/>
                {resultDriver?.status === 'loading' ? (
                  <TableLoading />
                ) : (
                  <tbody id="driver-table-body-container">
                    {resultDriver?.data?.result?.map((driver: any, index: number) => {
                      return (
                        <tr key={`driver-${index}`}>
                          <td className="pointer">
                            <UserInformation
                              avatar={driver?.avatar}
                              name={driver?.firstName}
                              lastName={driver?.lastName}
                              phoneNumber={driver?.phoneNumber}
                              isBlock={
                                driver?.schoolDriverInformation?.approved?.isApproved ===
                                false
                                  ? true
                                  : driver?.blocks?.length >= 1
                              }
                            />
                          </td>
                          <td className="" >
                            {driver?.schoolDriverInformation?.tagNumber
                              ? driver?.schoolDriverInformation?.tagNumber
                              : "نامشخص"}
                          </td>
                          <td >
                            <PlateNumberr
                              defaultValue={driver?.driverInformation?.plateNumber}
                              size="xs"
                              isEditable={false}
                            />
                          </td>
                          <td>
                            {driver?.driverInformation?.nationalCode}
                          </td>
                          {/* Status */}
                          <td className="pointer" >
                            <ShowConfirm
                              icon="fa-solid fa-car"
                              isConfirm={
                                driver?.schoolDriverInformation?.approved?.isApproved
                              }
                              title={t("approved")}
                            />
                          </td>

                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Container>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default ApproveDocuments;
